import { render } from "./FilterBlock.vue?vue&type=template&id=f23396f8"
import script from "./FilterBlock.vue?vue&type=script&lang=js"
export * from "./FilterBlock.vue?vue&type=script&lang=js"

import "./FilterBlock.vue?vue&type=style&index=0&id=f23396f8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__